import { CaseList } from '../../components';

const CasesPage = () => {
   return (
      <section>
         <CaseList />
      </section>
   );
};

export default CasesPage;
